<palantir-dialog [title]="'TAB_WARRANTIES_EQUIPMENT.DIALOG.TITLE' | translate" [formGroup]="form">
  <palantir-dialog-content class="p-0">
    <palantir-input class="mt-6 mx-6" [control]="searchControl" prefix="search-outline">
      <input type="text" [placeholder]="'TAB_WARRANTIES_EQUIPMENT.DIALOG.SEARCH_BY_NAME' | translate" [formControl]="searchControl" />
    </palantir-input>

    <palantir-text type="subtitle" size="base" class="ml-6">
      {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.TITLE' | translate }}
    </palantir-text>
    @if (!warrantiesTemplates().length) {
      <palantir-text type="description" size="xs" class="ml-6">
        {{ 'TAB_WARRANTIES_EQUIPMENT.NO_RESULTS.TITLE' | translate }}
      </palantir-text>
    }

    <ng-scrollbar class="w-full flex flex-col max-h-[300px]" [visibility]="'hover'" [autoHeightDisabled]="false">
      <div class="flex flex-col gap-2 p-6 pt-1">
        @if (warrantiesService.isLoading()) {
          <palantir-skeleton class="w-full h-52 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-52 rounded-lg"></palantir-skeleton>
          <palantir-skeleton class="w-full h-52 rounded-lg"></palantir-skeleton>
        } @else {
          @for (warrantyTemplate of warrantiesTemplates(); track warrantyTemplate) {
            <palantir-list-item
              (click)="toggleWarrantyTemplate(warrantyTemplate)"
              [attr.aria-selected]="isSelected(warrantyTemplate.id)()"
            >
              <palantir-list-item-prefix>
                <palantir-icon name="warranty-outline"></palantir-icon>
              </palantir-list-item-prefix>
              <palantir-list-item-content>
                <palantir-text type="title" [truncate]="true">
                  {{ warrantyTemplate.name }} - {{ warrantyTemplate.coverageDurationDays }}
                  {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.DAYS' | translate }}
                </palantir-text>
                <palantir-text type="description" [truncate]="true">
                  {{ warrantyTemplate.description }}
                </palantir-text>
              </palantir-list-item-content>
              <palantir-radio palantir-list-item-suffix [attr.aria-selected]="isSelected(warrantyTemplate.id)()"></palantir-radio>
            </palantir-list-item>
          }
        }
      </div>
    </ng-scrollbar>
  </palantir-dialog-content>

  <palantir-dialog-actions>
    <palantir-button theme="outline" (click)="close()">
      {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.BUTTONS.CANCEL' | translate }}
    </palantir-button>
    @if (warrantiesService.isLoading()) {
      <palantir-button [attr.disabled]="warrantiesService.isLoading()" icon="loading-outline" layout="prefix">
        {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.BUTTONS.SAVING' | translate }}
      </palantir-button>
    } @else {
      <palantir-button (click)="save()" [attr.disabled]="!form.valid || warrantiesService.isLoading()">
        {{ 'TAB_WARRANTIES_EQUIPMENT.DIALOG.BUTTONS.SAVE' | translate }}
      </palantir-button>
    }
  </palantir-dialog-actions>
</palantir-dialog>
